import { Injectable } from '@angular/core';

@Injectable()
export class LanguageApp {
  public static spanish_datatables = {
    processing: "<div class='loading'><img src='/assets/images/icons/ico_loading_bar.svg' /></div>",
    search: "Pesquisar:",
    lengthMenu: "Mostrar _MENU_ registos",
    info: "Mostrando os registos _START_ a _END_ num total de _TOTAL_",
    infoEmpty: "Mostrando 0 os registos num total de 0",
    infoFiltered: "(filtrado num total de _MAX_ registos)",
    infoPostFix: "",
    loadingRecords: "A carregar...",
    zeroRecords: "Não foram encontrados resultados",
    emptyTable: "Não há dados disponíveis na tabela",
    paginate: {
      first: "Primeiro",
      previous: "Anterior",
      next: "Seguinte",
      last: "Último"
    },
    aria: {
      sortAscending: ": Ordenar colunas de forma ascendente",
      sortDescending: ": Ordenar colunas de forma descendente"
    }
  }
}
